<template>
<v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Sign-up to access the Southview Directory</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
              <v-btn class="ma-2" color="warning" @click="instructions = !instructions">
                Read me first!
              </v-btn>
              <v-expand-transition>
                <v-card v-show="instructions" >
                  <v-card-text>
                    <p>Thank you for using the Southview Online Student Directory!  It is an easy way to get the contact info of other parents for birthday parties, play dates, or other events.</p>
                    <p>Before you begin here are some quick instructions:
                      <ol>
                        <li>Fill in the standard registration info (name, email, password)
                        </li>
                        <li>Provide the last name and student ID of your student.<br/>  
                          If you have more than one student you only need to use one student ID.
                          <ul>
                            <li>This information is used to verify that you are an actual Southview parent.</li>
                            <li>***If you have forgotten or can't find your child's student ID number, it is on the back of your student's iPad.</li>
                          </ul>
                        </li>
                      </ol>
                    </p>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
                <v-form v-model="valid" ref="form">
                  <v-text-field prepend-icon="person" name="fullName" v-model="fields.name" label="Your Name" type="text" :rules="[rules.required]"></v-text-field>
                  <v-text-field prepend-icon="person" name="email" v-model="fields.username" label="Email Address" type="text" :rules="[rules.required, rules.email]"></v-text-field>
                  <v-text-field id="password" prepend-icon="lock" name="password" v-model="fields.password" label="Create Password" type="password" :rules="[rules.required]"></v-text-field>
                  <v-text-field id="password2" prepend-icon="lock" name="password2" v-model="fields.password2" label="Verify Password" type="password" :rules="[rules.required, rules.passwordMatch]"></v-text-field>
                  <v-subheader>In order to access the directory please enter your child's last name and student ID number below.  
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                      </template>
                      Why do we need this?  The security of your personal information is important to us.  This helps us determine that the people who are accessing this site are actual Southview parents.
                    </v-tooltip>
                  </v-subheader>
                  <v-text-field id="lastName" name="lastName" v-model="fields.lastName" label="Last Name" type="text" :rules="[rules.required]"></v-text-field>
                  <v-text-field id="studentId" name="studentId" v-model="fields.studentId" label="Student ID" type="text" :rules="[rules.required]"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="!valid" @click="signUp" color="primary">
                  <v-icon v-if="!submitting">check</v-icon>
                  <v-progress-circular v-if="submitting" indeterminate></v-progress-circular>
                  Sign-up
                </v-btn>
              </v-card-actions>
              <v-snackbar
                v-model="snackbar"
                :color="snackbarType"
                :timeout="snackbarTimeout"
                top
              >
                {{ snackbarMessage }}
                <v-btn dark text @click="snackbar = false">
                  Close
                </v-btn>
              </v-snackbar>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
</template>

<script>
import firebase from 'firebase';
const axios = require('axios');

export default {
  name: 'SignUp',
  data () {
    return {
      fields: {
        name:'',
        username:'',
        password:'',
        password2:'',
        lastName:'',
        studentId:'',      
      },
      submitting:false,
      snackbar:false,
      snackbarMessage:'',
      snackbarType:'error',
      snackbarTimeout: 10000,
      valid: true,
      instructions:false,
      rules: {
        required: (value) => {
          let valid = !!value;
          return valid || 'Required.';
        }, 
        email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            let valid = pattern.test(value);
            return valid || 'Invalid e-mail.'
        },
        passwordMatch: (value) => {
          return (value === this.fields.password) || 'Passwords do not match.'
        }
      }
    }
  },
  computed: {

  },
  methods: {
 
    signUp() {
      this.submitting = true;
      let payload = {
        name:this.fields.name,
        username:this.fields.username,
        password:this.fields.password,
        password2:this.fields.password2,
        lastName:this.fields.lastName,
        studentId:this.fields.studentId
      };
      console.log('Submitting data: ', payload);
      axios.post(process.env.VUE_APP_SIGNUP_ENDPOINT, payload).then((resp) => {
        console.log('Response: ', resp)
        this.submitting = false;
        this.snackbarType = 'success';
        this.snackbarTimeout = 10000;
        this.snackbarMessage = 'User created successfully!  You should be automatically logged in and redirected to the site now.'
        this.snackbar = true;
        if(resp.data.token) {
          firebase.auth().signInWithCustomToken(resp.data.token).then((user) => {
            //automatically signed the user in, redirect
            console.log(user);
            this.$router.replace('/students');
          }).catch(function(error) {
            // Handle Errors here.
            console.log(error);
            this.submitting = false;
            this.snackbarTimeout = 0;
            this.snackbarMessage = 'There was an error attempting to log you in automatically.  Go to the Home Page and try to login again.';
            this.snackbarType = 'error';
            this.snackbar = true;
          });
        }
        //success, close modal
        //this.showPopup = false;
        //this.submitting = false;
        // this.confirmScreen = true;
      }).catch((err) => {
        console.log(` error:`, err);
        this.submitting = false;
        this.snackbarTimeout = 0;
        this.snackbarMessage = err.response.data;
        this.snackbarType = 'error';
        this.snackbar = true;
        //this.showPopup = false;
        //this.submitting = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
